import { Box, Typography, Button, styled } from "@mui/material";
import colors from "../../theme/Colours";

export const WishlistTitle = styled(Typography)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  marginBottom: "20px",
  fontFamily: "Poppins",
  fontSize: "32px",
  fontWeight: 500,
  color: theme.palette.text.secondary,
  [theme.breakpoints.down("md")]: {
    fontSize: "22px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "18px",
  },
}));

export const WishlistContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: theme.spacing(2.5),
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "stretch",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "row",
    gap: theme.spacing(1.5),
  },
}));

export const EmptyWishlistBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  width: "100%",
  padding: theme.spacing(3),
  gap: theme.spacing(2),
  minHeight: "150px",
  [theme.breakpoints.up("sm")]: {
    minHeight: "250px",
    padding: theme.spacing(4),
    gap: theme.spacing(3),
  },
  [theme.breakpoints.up("md")]: {
    minHeight: "350px",
    padding: theme.spacing(5),
    gap: theme.spacing(4),
  },
}));

export const EmptyWishlistImage = styled("img")(({ theme }) => ({
  width: "30px",
  height: "auto",
  maxWidth: "100%",
  marginBottom: theme.spacing(2),

  [theme.breakpoints.up("sm")]: {
    width: "120px",
    marginBottom: theme.spacing(3),
  },
  [theme.breakpoints.up("md")]: {
    width: "100px",
  },
}));

export const EmptyWishlistText = styled(Typography)(({ theme }) => ({
  color: "#828282",
  fontFamily: "Poppins",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: 1.6,
  maxWidth: "90%",
  textAlign: "center",

  [theme.breakpoints.up("sm")]: {
    fontSize: "18px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "20px",
  },
}));

export const ExploreButton = styled(Button)(({ theme }) => ({
  width: "200px",
  fontSize: "12px",
  fontFamily: "Roboto",
  height: "42px",
  color: colors.primaryButtonOrange,
  borderRadius: "4px",
  border: `1px solid ${colors.primaryButtonOrange}`,
  "&:hover": {
    backgroundColor: colors.primaryButtonOrangeHover,
    color: "#fff",
  },
  [theme.breakpoints.up("sm")]: {
    width: "200px",
    fontSize: "14px",
    height: "42px",
  },
}));
